import {FC} from 'react'

type VariantProps = {
  name: string
}

export const Variant: FC<React.PropsWithChildren<VariantProps>> = ({children}) => <>{children}</>
